import React, { useState } from "react";
import { Container, SearchContainer, SearchBar, ChipContainer } from "./styled";
import Button from "../../ReUsableComponents/Button";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { useDispatch, useSelector } from "react-redux";
import { getUserFromEmail } from "../../../../../Services/userService";
import { openAlert } from "../../../../../Redux/Slices/alertSlice";
import {
  boardMemberAdd,
  boardMemberDelete,
} from "../../../../../Services/boardService";
import { getAllUser } from "../../../../../Services/userService";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const useStyles = makeStyles({
  root: {
    maxWidth: "8rem",
    opacity: "70%",
  },
});

const ChipComponent = (props) => {
  const { name, surname, email, callback } = props;
  const classes = useStyles();
  return (
    <Tooltip
      TransitionComponent={Zoom}
      title={`${name} ${surname}`}
      size="small"
      placement="top"
      arrow
    >
      <Chip
        className={classes.root}
        onDelete={() => callback(email)}
        avatar={<Avatar>{name.toString()[0]}</Avatar>}
        label={name}
        size="small"
        color="secondary"
      />
    </Tooltip>
  );
};

const InviteMembers = () => {
  const [memberMail, setMemberMail] = useState("");
  const [members, setMembers] = useState([]);
  const [membersAll, setMembersAll] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const dispatch = useDispatch();
  const boardMembers = useSelector((state) => state.board.members);
  const boardId = useSelector((state) => state.board.id);

  React.useEffect(() => {
    const fetchUsers = async () => {
      const mapped = boardMembers
        .map((member) => ({
          name: member.name,
          surname: member.surname,
          email: member.email,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));

      setMembers(mapped);

      const allUsers = await getAllUser(dispatch);

      // Remove usuários que já estão em members
      const filteredUsers = (allUsers || [])
        .filter((user) => !mapped.some((member) => member.email === user.email))
        .sort((a, b) => a.name.localeCompare(b.name));

      setMembersAll(filteredUsers);
    };

    fetchUsers();
  }, []);

  const handleAddClick = async () => {
    if (!selectedUser) return;

    // Verifica se o email já é membro do board
    const checkMember = boardMembers.filter((m) => m.email === memberMail);

    if (checkMember.length > 0) {
      dispatch(
        openAlert({
          message: `já é membro deste quadro!`,
          severity: "error",
        })
      );
      setSelectedUser(null);
      setMemberMail("");
      return;
    }

    // Busca usuário pelo e-mail
    const result = await getUserFromEmail(memberMail, dispatch);
    if (!result) return;

    // Adiciona o membro ao quadro
    await boardMemberAdd(boardId, result, dispatch);

    // Atualiza a lista de membros do board localmente
    setMembers((prev) => [...prev, result]);

    // Remove o usuário da lista de todos os disponíveis (por exemplo, lista para autocomplete)
    setMembersAll((prev) => prev.filter((user) => user.email !== result.email));

    // Limpa campos
    setSelectedUser(null);
    setMemberMail("");
  };

  const handleDelete = async (email) => {
    const newMembers = members.filter((member) => member.email !== email);
    setMembers([...newMembers]);

    const result = await getUserFromEmail(email, dispatch);
    await boardMemberDelete(boardId, result, dispatch);
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  return (
    <Container>
      <SearchContainer style={{ flexDirection: "column", gap: "0.5rem" }}>
        <Autocomplete
          options={membersAll}
          getOptionLabel={(option) => `${option.name} ${option.surname}`}
          style={{ width: "100%" }}
          value={selectedUser}
          onChange={(event, newValue) => {
            if (newValue) {
              setSelectedUser(newValue);
              setMemberMail(newValue.email);
            } else {
              setSelectedUser(null);
              setMemberMail("");
            }
          }}
          renderInput={(params) => (
            <TextField {...params} label="Buscar membro" variant="outlined" />
          )}
        />
        <Button
          title="Adicionar usuário"
          style={{ alignSelf: "flex-start" }}
          clickCallback={handleAddClick}
        />
      </SearchContainer>
      <p>Usuários do Quadro</p>
      <ChipContainer>
        {members.map((member) => {
          return (
            <ChipComponent
              key={member.email}
              callback={handleDelete}
              {...member}
            />
          );
        })}
      </ChipContainer>
    </Container>
  );
};

export default InviteMembers;
